import { fetcher, SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  BulkActionCustomersParams,
  CampaignListItem,
  GetCampaignListParams,
  SendExemptionInvitationResponse,
} from './types';

export function useCampaignList(params: GetCampaignListParams): {
  campaigns: CampaignListItem[] | undefined;
  isLoading: boolean;
  error: Error | null;
  mutate: (
    data?: CampaignListItem[]
  ) => Promise<CampaignListItem[] | undefined>;
} {
  const query = new URLSearchParams();

  if (params.corporationId) {
    query.append('corporationId', params.corporationId.toString());
  }
  if (params.type) {
    query.append('type', params.type);
  }

  const { data, error, isLoading, mutate } = useSWR<CampaignListItem[]>(
    `email-campaign/list?${query}`,
    SWRFetcher({ method: 'GET' }, undefined)
  );

  return {
    campaigns: data,
    isLoading,
    error,
    mutate: mutate as (
      data?: CampaignListItem[]
    ) => Promise<CampaignListItem[] | undefined>,
  };
}

export async function useSendExemptionRequestEmail(
  body: BulkActionCustomersParams
): Promise<{
  success: boolean;
  error?: string;
  data?: SendExemptionInvitationResponse;
}> {
  try {
    const url = `email-campaign/send-invitations`;
    const response = await fetcher(
      url,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to send exemption request email',
      };
    }

    const data = await response.json();

    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to send exemption request email';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
